import type { CSSProperties } from 'react';

import { ARROW_GAP_PX } from '@/components/Illustrations/arrowPlacement';

/**
 * The hand-drawn arrow in its own units — its `viewBox` — with the three points the layout needs,
 * read off the artwork: the point of the arrowhead, the top of the loop, which is the drawing's
 * highest ink, and the free end of the line.
 */
export const ARROW_ARTWORK = {
    width: 485,
    height: 189,
    tip: { x: 472.37, y: 54.22 },
    crest: { x: 129.36, y: 8.24 },
    tail: { x: 15.77, y: 13.35 },
} as const;

/**
 * How far into the selected-employee card, from its leading edge, the arrowhead comes up: over the
 * avatar, so the arrow lands on the person rather than on the empty end of the row.
 */
const TIP_INSET_PX = 96;

/**
 * Where the drawing sits, in the selected-employee card's own positioned wrapper: the arrowhead
 * stops `ARROW_GAP_PX` short of the card's bottom edge and comes up over its avatar, and the loop
 * and the tail trail down and to the left from there.
 *
 * Both offsets are read from that one card, so the drawing follows it instead of sitting at a fixed
 * distance from the top of the header — which is what laid the loop over the hero paragraph, a
 * paragraph whose height is whatever its translation needs.
 */
export const SELECTED_EMPLOYEE_ARROW_STYLE: CSSProperties = {
    top: `calc(100% - ${ARROW_ARTWORK.tip.y - ARROW_GAP_PX}px)`,
    left: `${TIP_INSET_PX - ARROW_ARTWORK.tip.x}px`,
    width: `${ARROW_ARTWORK.width}px`,
    height: `${ARROW_ARTWORK.height}px`,
};
